import {Typography, useTheme} from '@mui/material';
import Box from '@mui/material/Box';
import {grey} from '@mui/material/colors';

import {normaliseValue} from '../../../../utils';
import CustomizedLinearProgress from '../../../progress/LinearProgress';

// eslint-disable-next-line react/prop-types
const ExportProgressBar = ({value, maxValue}) => {
  const progress = normaliseValue(value, maxValue);
  const theme = useTheme();

  return (
    <Box sx={{display: 'flex', alignItems: 'center'}}>
      <Box sx={{width: '100%', mr: 1, overflow: 'hidden', borderRadius: 5}}>
        <CustomizedLinearProgress
          filledColor={theme.palette.primary.main}
          emptyColor={grey[200]}
          variant="determinate"
          value={progress}
          stylesOverrides={{
            height: 12
          }}
        />
      </Box>
      <Box sx={{minWidth: 35}}>
        <Typography variant="body2" sx={{color: 'text.secondary'}}>
          {`${Math.round(progress)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

export default ExportProgressBar;
